import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-thick-left': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M22.9 8.49H11.151a.25.25 0 0 1-.25-.25V3.215A1 1 0 0 0 9.2 2.507L.4 11.278a1 1 0 0 0 0 1.415l8.8 8.8a1 1 0 0 0 1.707-.707V15.74a.25.25 0 0 1 .25-.25H22.9a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"/>`,
    },
});
